"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const toPairs_1 = __importDefault(require("lodash/toPairs"));
const toCamelCase = (obj) => {
    if (!(0, isObject_1.default)(obj)) {
        return obj;
    }
    if ((0, isArray_1.default)(obj)) {
        return obj.map((v) => toCamelCase(v));
    }
    const ret = {};
    (0, toPairs_1.default)(obj).forEach(([k, v]) => {
        ret[(0, camelCase_1.default)(k)] = toCamelCase(v);
    });
    return ret;
};
exports.default = toCamelCase;
//# sourceMappingURL=camelCase.js.map